// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kEZ7O","col":"styles_col__3uEpu"};